import { Action, initialState, State } from 'store/store';

export const setModuleToReviewMode = (
  state: State = initialState,
  { data }: Action
): State => {
  //
  const interactionsSeen = Object.values(state.blocks)
    .filter(b => {
      const { type, meta } = b;
      const { subType } = meta || {};

      return (
        type?.toLowerCase() === 'interaction' ||
        (type !== 'AnimationGroup' &&
          meta?.subType?.toLowerCase() === 'interaction')
      );
    })
    .map(i => {
      return i?.id;
    });

  //

  return {
    ...state,
    interactionsLocked: [],
    interactionsSeen,
  };
};
